import { GlobalConfigType } from 'actions'
import { store } from 'reducers'
import { checkFirst2Letters, parseFullName } from 'utils'

export const IneligiblePartiesList: Record<string, string> = {
  guarantor: 'Guarantor',
  appraiser: 'Appraiser',
  contractor: 'Contractor',
  settlement: 'Settlement Agent',
}

export const getSimliarIneligibleParties = () => {
  const rtl: Record<string, Array<Array<string>>> = {}
  try {
    const { loanDetail, borrower, globalConfigReducer } = store.getState()
    const ineligibleParties = globalConfigReducer[GlobalConfigType.IneligibleParties]

    Object.keys(IneligiblePartiesList).map((key) => {
      rtl[key] = []
      const loanPartyNames: Array<Array<string>> = []
      Object.keys(loanDetail?.closeParties)?.map((subKey) => {
        const { FirstName, LastName } = loanDetail.closeParties[subKey]
        loanPartyNames.push([FirstName, LastName])
      })
      Object.keys(borrower).map((subKey) => {
        const { firstName, lastName } = borrower[subKey]
        loanPartyNames.push([firstName, lastName])
      })
      loanPartyNames.map((party) => {
        ineligibleParties[key]?.map((item: string) => {
          const { firstName, lastName } = parseFullName(item)
          if (checkFirst2Letters(firstName, party[0]) && checkFirst2Letters(lastName, party[1])) {
            const originName = `${party[0]} ${party[1]}`
            const existingIdx = rtl[key].findIndex((v) => v[0] === originName && v[1] === item)
            if (existingIdx === -1) rtl[key].push([originName, item])
          }
        })
      })
    })
  } catch {}
  return rtl
}

export const isIneligiblePartyCleared = () => {
  const { loan } = store.getState()
  const ineligibleParties = getSimliarIneligibleParties()

  let rtl = true
  Object.keys(ineligibleParties).forEach((key) => {
    ineligibleParties[key]?.map((item) => {
      if (!loan.ineligiblePartyCleared?.[`${item[0]}-${item[1]}`]) rtl = false
    })
  })

  return rtl
}
